/** Shared TanStack Query keys for Partner Dashboard schema definitions. */
export const schemaDefinitionKeys = {
  all: ['schemaDefinitions'] as const,
  list: () => [...schemaDefinitionKeys.all, 'list'] as const,
  detail: (schemaDefinitionId: string) =>
    [...schemaDefinitionKeys.all, 'detail', schemaDefinitionId] as const,
} as const;
